import { memo, ReactNode, Ref, SyntheticEvent, useCallback } from 'react'
import { ITooltipProps, Tooltip } from '@cargomart/ui'
import IconError from 'assets/error.svg?react'
import IconHelp from 'assets/help.svg?react'
import cn from 'classnames'
import IconSpam from 'remixicon/icons/System/spam-2-line.svg?react'

import s from './IconTooltip.module.less'

export interface IIconTooltipProps {
  Icon: TSvgIconComponent
  children?: ReactNode
  className?: string
  containerSize?: ISvgIconProps['containerSize']
  placement?: ITooltipProps['placement']
  rotate?: ISvgIconProps['rotate']
  size?: ISvgIconProps['size']
}

export const IconTooltip = memo(function IconTooltip({
  className,
  children,
  placement = 'right',
  Icon,
  size = 'nm',
  containerSize
}: IIconTooltipProps) {
  const handleClick = useCallback((e: SyntheticEvent) => {
    e.stopPropagation()
  }, [])

  const preparedClassName = cn(className, s.help, 'flex')

  return (
    <Tooltip content={children} placement={placement}>
      {({ ref, ...triggerProps }) => (
        <span {...triggerProps} ref={ref as Ref<HTMLSpanElement>} className={preparedClassName} onClick={handleClick}>
          <Icon containerSize={containerSize} size={size} />
        </span>
      )}
    </Tooltip>
  )
})

export const IconTooltipError = ({ className, ...props }: Omit<IIconTooltipProps, 'Icon'>) => (
  <IconTooltip {...props} Icon={IconError} className={cn(s.error, className)} />
)
export const IconTooltipHelp = (props: Omit<IIconTooltipProps, 'Icon'>) => <IconTooltip {...props} Icon={IconHelp} />

export const IconTooltipWarning = (props: Omit<IIconTooltipProps, 'Icon'>) => <IconTooltip {...props} Icon={IconSpam} />

// eslint-disable-next-line import/no-default-export
export default IconTooltip
